<template>
	<header v-if="backgroundVideo" :class="[fullscreen, specialClass ]" >
		<div class="intro-header">
			<video autoplay="autoplay" :poster="backgroundImg" id="bgvid" muted="muted" loop="loop" :src="backgroundVideo"></video>
		</div>
		<b-row no-gutters>
			<slot></slot>
		</b-row>
	</header>
	<header v-else :class="[fullscreen, specialClass ]" v-bind:style=" { background: 'url('+backgroundImg+')', backgroundSize: 'cover', backgroundPosition: 'center' }" >
		<!-- style="background: url('images/landing/head-landing.png'); background-size: cover" -->
		<b-row no-gutters>
			<slot></slot>
		</b-row>
	</header>
</template>

<script>
  export default {
	name: 'v-section-header',
	props: {
		fullscreen: {default: "fullscreen"},
		specialClass: String,
		backgroundImg: {default: '', type: String},
		backgroundVideo: {default: null, type: String}
	}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.has-image:before{
	content: '';
    background-color: rgba(0, 0, 0, 0.45);
    position: absolute;
    top: 0;
    width: 100%;
	height: 100%;
	max-width: 1800px;
	margin-left: auto;
	margin-right: auto;
}
.has-image{
	background-size: cover;
}
.mobile{
	position: relative;
}
.intro-header {
	overflow: hidden;
	clip: rect(0, auto, auto, 0);
	position: absolute;
	width: 100%;
	height: 100vh;
	max-width: 1800px;
}
video#bgvid {
    position: fixed;
    top: 50%;
    left: 50%;
    min-width: 100%;
    min-height: 100%;
    width: auto;
    height: auto;
    z-index: -1;
    -ms-transform: translateX(-50%) translateY(-50%);
    -moz-transform: translateX(-50%) translateY(-50%);
    -webkit-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
    background-size: cover;
}

audio, canvas, progress, video {
    display: inline-block;
    vertical-align: baseline;
}
</style>
